<!-- C153176-4618 Responsive Design-->
<p-dialog [(visible)]="display" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
  [styleClass]="'contextMenuModal settingsModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000"
  [closeOnEscape]="true" [style]="{'height':'667px','max-width':'930px', 'width': '100%'}" [resizable]="false">
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between">
      <span style="font-size: 16px;color:#FFFFFF;font-family:OpenSansSemiBold;line-height: 21.79px;font-weight: 600;">Dashboard Settings</span>
      <button type="button" (click)="hideModal()" class="d-flex flex-row close qma-text"
        style="margin: 0px 6px 0px 0px;">
        <img src="assets/qwyn/icons/close-grey.svg" alt="Close">
      </button>
    </div>
  </p-header>

  <div class="gfid-body">

    <div class="d-flex flex-row pe-4">
      <p-tabView id='dashboard' class="adminview dashsettingview" [scrollable]="false"  [(activeIndex)]="currentTabIndex"
      (onChange)="onTabChange($event)"
        [style]="{'height':'39.8em','overflow': 'hidden', 'position': 'relative'}">
        <p-tabPanel header="Mailbox Statistics" class="tab-view-cls">
          <form [formGroup]="advSearchForm">
            <div>
              <div>
                <div style="font-size:14px; font-family:OpenSans; font-weight: normal; margin-left: 16px;font-weight: 400;">Please
                  select <span style='font-family:OpenSansBold;'>any four</span> options to display in your status circles:</div>
                <div class="d-flex flex-row flex-wrap py-3"
                  style="justify-content:start;  margin-left:19px">
                  <div class="d-flex flex-column" style="margin-right: 50px">
                    <div class="mb-2">
                      <ins class="heading-style">Messages</ins>
                    </div>
                    <div class="d-flex flex-column flex-nowrap advance-search-elem">
                      <div>
                        <app-checkbox-list #messages [name]="'groups'" [search]="false" [items]="messagesGroups"
                          [listStyle]="{'width':'22em','height':'41vh', 'margin-top': '0.5em','font-size':'16px !important'}"
                          (onItemChecked)="getSelectedMessage($event)"></app-checkbox-list>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <div class="mb-2">
                      <ins class="heading-style">My Views</ins>
                    </div>
                    <div class="d-flex flex-column flex-nowrap advance-search-elem">
                      <app-checkbox-list #myViews [placeholder]="'Quick Search...'" [name]="'tag'" [items]="myViewJson"
                        [listStyle]="{'width':'22em','height':'34vh','font-size':'16px !important'}"
                        (onItemChecked)="getMyViews($event)"></app-checkbox-list>
                    </div>
                  </div>
                </div>
                <div *ngIf="counterFlag"
                  style="font-size:16px; font-family:OpenSans; font-weight: normal; margin-left: 16px; color:#ff0000">
                  Note: Select only four option to display in your status circles.</div>
              </div>
            </div>
          </form>

        </p-tabPanel>
        <p-tabPanel header="Assigned Groups">
          <form [formGroup]="advSearchForm">
    <div>
    <div style="font-size:14px; font-family:OpenSans; font-weight: normal; font-weight: 400;margin-left: 16px;"> Please select groups whose data you’d like to see displayed on dashboard:</div>

            
            <div class="d-flex flex-row flex-wrap py-3" style="justify-content:start; margin-left: 50px">
              <div class="d-flex flex-column">
                <div class="mb-2">
                  <ins class="heading-style">List of Groups</ins>
                </div>
                <div class="d-flex flex-column flex-nowrap advance-search-elem">
                  <app-checkbox-list #groupname [placeholder]="'Quick Search...'" [name]="'value'" [items]="groupNames"
                    [listStyle]="{'height':'34vh', 'width':'25em'}" checked="groupNames.binary"
                    (onItemChecked)="getSelectedGroup($event)"></app-checkbox-list>
                </div>
                <div *ngIf="isAssignedGroupEmpty" style="font-size:14px; display: flex; justify-content: center; color: #ff0000; font-weight: 400;margin-left: 16px;"> Please select atleast one group</div>
              </div>
            </div>
            </div>
          </form>
        </p-tabPanel>
        <p-tabPanel header="Request Type & Assigned Owners">
          <div
            style="font-size:14px; font-family:OpenSans; font-weight: normal; margin-left: 16px;font-weight: 400;margin-right: 16px;">
            Please pick request types and owners, from the pre-selected “Assigned Groups” in the dropdown, whose data you’d <br> like to
            see displayed on dashboard:</div>
          <div style="margin-left:50px;">
            <div class="d-flex flex-row flex-nowrap align-items-end w-75 pe-2 mt-3" style='padding-bottom: 8px;'>
              <label for="from" class="flex-grow" style="color: #272727;font-size: 14px; font-weight: 600;font-family:OpenSansSemiBold">Assigned
                Group</label>
              <div class="w-75 ps-2">
                <p-dropdown [styleClass]="'prime-dd-dashboard'" class="drop-down w-25 group-details-input"
                  [(ngModel)]="selectedGrp" [options]="selectedGroup"
                  (onChange)="displayRequestType($event)"></p-dropdown>
              </div>
            </div>
            <div style='padding-top: 8px;'>
              <div class="d-flex flex-row flex-wrap py-3" style="justify-content:start">
                <div class="d-flex flex-column" style="margin-right: 50px">
                  <div class="mb-2">
                    <ins class="heading-style">Request Type</ins>
                  </div>
                  <div class="d-flex flex-column flex-nowrap advance-search-elem">
                    <app-checkbox-list #requestTypes [placeholder]="'Quick Search...'" [name]="'request'"
                      [items]="requestTypes" [listStyle]="{'height':'20vh', 'width':'22em'}"
                      (onItemChecked)="getSelectedRequestType($event)"></app-checkbox-list>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="mb-2">
                    <ins class="heading-style">Owner</ins>
                  </div>
                  <div class="d-flex flex-column flex-nowrap advance-search-elem">
                    <app-checkbox-list #ownerTypes [placeholder]="'Quick Search...'" [name]="'tag'"
                      [items]="assignedOwner" [listStyle]="{'height':'20vh', 'width':'22em'}"
                      (onItemChecked)="getSelectedOwner($event)"></app-checkbox-list>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Client Inquiry Monitor">
          <div
            style="font-size:14px; font-family:OpenSans, sans-serif; margin-left: 16px;font-weight: 400;margin-right: 16px;color: #272727">
            Please assign threshold limits to the three default client categories to keep track of on the dashboard:</div>
            <div style='padding-top: 8px;'>
          <div class="d-flex flex-row flex-wrap top-adv-container py-3" style='padding-top:8px'>
            <div class="d-flex flex-column">
              <div class="mb-2">
                <ins class="heading-style">Client Categories</ins>
              </div>
              <div class="d-flex flex-column flex-nowrap advance-search-elem">
                <app-checkbox-list-input #heatmap [placeholder]="'Quick Search...'" [name]="'heatmap'"
                  [items]="heatMapJson" [listStyle]="{'height':'18vh','width':'360px','overflow-x':'auto','padding-right':'8px'}" [tags]="tagLimits"
                  (onItemChecked)="getSelectedHeat($event)" [placeholderin]="'Set limit here'" search='false'
                  (onInputChange)="changeInputs($event)"></app-checkbox-list-input>
              </div>
            </div>
          </div></div>
        </p-tabPanel>
        <p-footer style="position: fixed; width: 100% ; bottom: 24px; right: 0;">
          <div class="d-flex flex-row footer-btn-container"></div>
          <div class="d-flex flex-row flex-wrap bottom-button-holder pb-2 pt-3 justify-content-end" >
            <button type="reset" class="btn clear-btn me-4" (click)="hideModal()">Cancel</button>
            <button type="submit" (click)="postDashboarSettingData()" class="btn search-btn">Submit</button>
          </div>
        </p-footer>
      </p-tabView>
    </div>
  </div>
</p-dialog>
<p-dialog [(visible)]="errMsgFlag" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
  [styleClass]="'contextMenuModal successModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000"
  [closeOnEscape]="true" [style]="{width: '30%', 'margin-left':'150px'}">
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between">
      <h6 class="success-title">Error Message</h6>
      <button type="button" (click)="closeErrModal()" class="d-flex flex-row close qma-text">
        <img src="assets/Inbox/close_icon_u73.svg" alt="Close">
        <h6>CLOSE</h6>
      </button>
    </div>
  </p-header>
  <div class="success-msg">{{this.errMsg}}</div>
</p-dialog>

<p-toast position="center" (onClose)="onReject()" styleClass="custom-toast" key="custom" [baseZIndex]="5000"></p-toast>